module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external "ca-ui-carbon-toolkit"
// module id = 4
// module chunks = 0 1 2